<template>
  <div
    tabindex="0"
    :data-id="propertySection.client_id"
    data-type="Section"
    class="form-element builder-element property-section"
    :class="propertyClasses"
    v-on:focus="replaceIdInRoute($event, true)"
    @click.stop="replaceIdInRoute"
  >
    <div class="title-bar">
      <icon :class="ObjectModelPropertyDefinition.getIcon(property_type)">
        <span class="sr-only">Focused Element: {{ObjectModelPropertyDefinition.getDisplayName(property_type)}}</span>
      </icon>
      <strong>
        {{ObjectModelPropertyDefinition.getDisplayName(property_type)}}
        <debug-sort-order :sortable="propertySection"/>
      </strong>
      <move-destroy
        :card="propertySection"
        @remove:card="handleRemove"
        class="suffix"
        :remove-enabled="removeEnabled"
        :remove-tooltip="removeTooltip"
      />
    </div>

    <row>
      <column class="row-title">
        <div :id="`scroll-to-label-${propertySection.client_id}`"/>
        <labelable
          ref="labelableComponent"
          v-on="$listeners"
          v-bind="$attrs"
          :is-selected="propertySection.isSelected"
          v-model="propertySection.label_title"
          placeholder="Enter a section name..."
        ></labelable>
      </column>
    </row>

    <div class="grid">
      <div>
        <template v-if="properties.length">
          <base-object-model-property
            v-for="property in properties"
            :key="property.client_id"
            :object-model-property="property"
          />
        </template>
        <empty-drag-zone v-else></empty-drag-zone>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import PropertySection from "~/models/objectModels/propertySection";
import {Hash} from "~/interfaces/hashInterfaces";
import MoveDestroy from "~/components/moveDestroy.vue";
import EmptyDragZone from "~/components/emptyDragZone.vue";
import BaseObjectModelProperty from "./base-object-model-property.vue";
import routerSelectedMixinFactory from "~/mixins/routerSelectedMixinFactory";
import routerMixin from "~/mixins/routerMixin";
import Labelable from "~/components/modelProperties/labelable.vue";
import DebugSortOrder from "~/components/debug/debug-sort-order.vue";
import ObjectModelPropertyDefinition from "~/models/objectModelProperties/objectModelPropertyDefinition";

export default Vue.extend({
  mixins: [
    routerMixin,
    routerSelectedMixinFactory('propertySection', '.property-section'),
  ],
  components: {
    BaseObjectModelProperty,
    MoveDestroy,
    EmptyDragZone,
    Labelable,
    DebugSortOrder,
  },
  props: {
    propertySection: {
      type: Object as () => PropertySection,
      required: true,
    },
  },
  data: function() {
    return {
      ObjectModelPropertyDefinition: ObjectModelPropertyDefinition,
      property_type: 12 // ObjectModelPropertyRootType.Section
    }
  },
  computed: {
    propertyClasses(): Hash<boolean> {
      return {
        active: this.propertySection.isSelected,
      };
    },
    properties() {
      return this.propertySection.properties
    },
    removeEnabled() {
      return this.propertySection.canDestroy
    },
    removeTooltip(): string | null {
      if (this.removeEnabled) {
        return null
      } else {
        return 'Deleting populated sections is not allowed. Please remove all properties to delete.'
      }
    }
  },
  methods: {
    handleRemove() {
      this.propertySection.destroy();
    },
    setSelected(propertySection: PropertySection): void {
      propertySection.select()
    }
  },
});
</script>
